import { CallListSchema, DBDocSchema } from '@pwp-common';

import { defaultCommunicationWorkflowConfigEditorOutput } from '../../../call-list-communication-workflow-config/editor-output/default-communication-workflow-config-editor-output';
import { defaultOfferConfigRingTimeEditorOutput } from '../../../call-list-offer-config-ring-time/editor/editor-output/default-offer-config-ring-time-editor-output';

import { CallListEditorOutput } from './call-list-editor-output';

export const defaultCallListEditorOutput: CallListEditorOutput = {
  id: DBDocSchema.GenericDefaults.id,
  displayName: CallListSchema.Defaults.displayName,
  description: CallListSchema.Defaults.description,
  calleeEntities: [],
  offerConfig: {
    ringTime: defaultOfferConfigRingTimeEditorOutput,
  },
  onNoUserLeftToDialModIncCallCommands: {
    commands: CallListSchema.Defaults.onNoUserLeftToDialModIncCallCommands.map((command) => command.serialize()),
  },
  communicationWorkflowConfig: defaultCommunicationWorkflowConfigEditorOutput,
};
